import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import { OtpLogin } from '@cvg/react-otp-auth'
import { useLanguageContext } from '@cvg/react-hooks'

import auth from '@services/auth'

import Page from '@components/Page'

import styles from './styles.module.css'

const Login = () => {
  const navigate = useNavigate()
  const { languageId } = useLanguageContext()

  if (auth.getUser()) return <Navigate to='/' replace />

  return (
    <Page className={styles.login}>
      <Page.Header />
      <Page.Content>
        <OtpLogin auth={auth} languageId={languageId} redirectCallback={() => navigate('/')} />
      </Page.Content>
    </Page>
  )
}

export default Login
